import styled from "styled-components";

import { Modal } from "components/Modal";

export const FeatureDetailsModalContainer = styled(Modal)`
  .modal-content {
    padding: 0px;
    border: 0;

    .modal-body {
      margin-top: 0px;
      padding: 0px;
      text-align: center;

      .heading {
        display: flex;
        align-items: center;
        padding: 14px 15px;
        background-color: ${({ theme }) => theme.modal.bg.secondary};
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;

        h2 {
          width: 100%;
          text-align: center;
          color: ${({ theme }) => theme.card.font.tertiary};
          font-size: 20px;
          font-weight: 500;
          margin-bottom: 0px;
        }
      }

      .sub-content {
        padding: 20px 30px 30px;
      }

      p {
        font-size: 15px;
        margin-bottom: 22px;
        color: ${({ theme }) => theme.card.font.tertiary};
      }

      button {
        width: 100%;
        font-size: 14px;
        font-weight: 500;
        height: 36px;
      }
    }
  }
`;
